const ITEMS = [
  "Spedizioni veloci in tutta Italia",
  "Disponibilità taglie in tempo reale",
  "Consulenza diretta su WhatsApp",
  "Qualità selezionata a mano",
  "Boutique accogliente & rapporto familiare",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee-strip"
      className="border-y border-ink/10 py-4 bg-cream overflow-hidden"
      aria-hidden="true"
    >
      <div className="mq-track flex items-center gap-10 text-xs uppercase tracking-[0.16em] font-medium text-ink/70">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 shrink-0">
            <span>{item}</span>
            <span>•</span>
          </span>
        ))}
      </div>
    </div>
  );
};
